<template>
  <div class="location-header position-relative" v-if="location">
    <LMap
      class="location-header"
      :zoom="map.zoom"
      :center="map.center"
      ref="leaflet"
      @ready="addBasemapLayer(BASEMAP_ACTIVE)"
    >
      <LMarker :lat-lng="markerLatLng">
        <MarkerPin></MarkerPin>
      </LMarker>
    </LMap>
    <div
      style="
        position: absolute;
        pointer-events: none;
        top: 0;
        z-index: 999;
        text-align: center;
      "
      class="d-flex justify-content-center w-100"
    >
      <div
        class="h1 bg-white m-2 p-2 flex-none rounded border border-light"
        style="pointer-events: initial"
      >
        Location '{{ location.name }}'
      </div>
    </div>
  </div>
</template>

<script>
import * as L from "leaflet";
import * as EsriLeaflet from "esri-leaflet";
import * as EsriLeafletRenderers from "esri-leaflet-renderers";
import { latLngBounds } from "leaflet";
import {
  LMap,
  LTileLayer,
  LLayerGroup,
  LMarker,
  LPopup,
  LTooltip,
  LRectangle,
  LCircle,
  LControlZoom,
} from "vue2-leaflet";
import MarkerPin from "../common/map/MarkerPin.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "LocationHeader",
  components: {
    LMap,
    LTileLayer,
    LLayerGroup,
    LMarker,
    LPopup,
    LTooltip,
    LRectangle,
    LCircle,
    LControlZoom,
    MarkerPin,
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      map: {
        zoom: 12,
        center: L.latLng(this.location.lngLat),
        url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
        attribution:
          '&copy; <a target="_blank" rel="noopener noreferrer" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      markerLatLng: L.latLng(this.location.lngLat),
    };
  },
  computed: {
    ...mapGetters({
      BASEMAP_ACTIVE: "map/BASEMAP_ACTIVE",
    }),
  },
  methods: {
    addBasemapLayer(newLayer, oldLayer) {
      const map = this.$refs.leaflet && this.$refs.leaflet.mapObject;
      if (!map || !newLayer) return;
      if (oldLayer) {
        try {
          map.removeLayer(oldLayer);
        } catch (e) {}
      }
      newLayer.addTo(map);
      map.invalidateSize();
    },
  },
  watch: {
    BASEMAP_ACTIVE(newLayer, oldLayer) {
      this.addBasemapLayer(newLayer, oldLayer);
    },
    location: {
      handler(newLocation) {
        if (newLocation && newLocation.lngLat) {
          this.map.center = L.latLng(newLocation.lngLat);
          this.markerLatLng = L.latLng(newLocation.lngLat);
        }
      },
    },
  },
};
</script>

<style scoped>
.location-header {
  width: 100%;
  height: 40vh;
}
</style>
